export enum PeriodStatuses {
    notStarted = "Not Started",
    active = "Active",
    suspended = "Suspended",
    completed = "Completed",
    canceled = "Canceled"
}


// WEBPACK FOOTER //
// ./src/app/models/periodStatus.ts